import React, { useEffect } from "react";
import Compensation from "../../../images/Compensation.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DropdownComponent from "../../../containers/Dropdown";
import { EMAIL_PLACEHOLDER, MODAL_SIZE, PHONE_PLACEHOLDER, POSTAL_CODE_PLACEHOLDER, PROVINCEDRPDATA } from "../../../App.config";
import backArrow from "../../../images/back-arrow.svg";
import moment from "moment";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import add from "../../../images/add.svg";
import ManagerDetailModal from "../../Std/ManagerDetailModal.jsx";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";


const EmployeeInformation = ({
  state,
  onSubmit,
  previousStep,
  props,
  handleChanges,
  onDateChange,
  handlePhoneNumber,
  handleSIN,
  onDropDownChange,
  resetAirApplicationUrl,
  onAddManager,
  country
}) => {
  // Set air pdf url to initial state
  useEffect(() => {
    resetAirApplicationUrl();
  }, []);

  // const onAddManager = () => {
  //   props.openSetModalAction(
  //     <ManagerDetailModal
  //       {...props}
  //     // jobID={state.jobTitle.value}
  //     // locationID={state.location.value}

  //     />,
  //     MODAL_SIZE.MODAL_SM
  //   );
  // };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t(
                    "AIR-Employee-Information.form.heading.text"
                  )}
                </span>
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeeFirstName"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeFirstName"
                        value={state.employeeFirstName.value}
                        ref={state.employeeFirstName.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employeeFirstName.isEditable}
                      />
                      {state.employeeFirstName?.error && (
                        <span className="error">
                          {state.employeeFirstName.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeeLastName"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeLastName"
                        value={state.employeeLastName.value}
                        ref={state.employeeLastName.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employeeLastName.isEditable}
                      />
                      {state.employeeLastName?.error && (
                        <span className="error">
                          {state.employeeLastName.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.SIN"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder="XXX-XXX-XXX"
                        name="sin"
                        value={state.sin.value}
                        ref={state.sin.ref}
                        onChange={handleSIN}
                        className="form-control"
                      />
                      {state.sin?.error && (
                        <span className="error">{state.sin.error}</span>
                      )}
                    </div>
                  </div>
                  {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.HealthCardNo"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeHealthCardNo"
                        value={state.employeeHealthCardNo.value}
                        ref={state.employeeHealthCardNo.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.employeeHealthCardNo?.error && (
                        <span className="error">
                          {state.employeeHealthCardNo.error}
                        </span>
                      )}
                    </div>
                  </div> */}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.Employee"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employee"
                        value={state.employee.value}
                        ref={state.employee.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employee.isEditable}
                      />
                      {state.employee?.error && (
                        <span className="error">{state.employee.error}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.DateOfBirth"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        readOnly={!state.dateOfBirth.isEditable}
                        id="dateOfBirth"
                        selected={state.dateOfBirth.value && state.dateOfBirth.value}
                        onChange={(e) => {
                          if (state.dateOfBirth.isEditable)
                            onDateChange(e, "dateOfBirth");
                        }}
                        maxDate={moment().toDate()}
                        ref={state.dateOfBirth.ref}
                        className="form-control"
                        placeholderText={props.context.t(
                          "AIR-Employer-Information.form.common.DateFormat"
                        )}
                        dropdownMode="select"
                      />
                      {state.dateOfBirth?.error && (
                        <span className="error">{state.dateOfBirth.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.DateOfHire"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        readOnly={!state.dateOfHire.isEditable}
                        id="dateOfHire"
                        selected={state.dateOfHire.value && state.dateOfHire.value}
                        onChange={(e) => {
                          if (state.dateOfHire.isEditable)
                            onDateChange(e, "dateOfHire");
                        }}
                        maxDate={moment().toDate()}
                        ref={state.dateOfHire.ref}
                        className="form-control"
                        placeholderText={props.context.t(
                          "AIR-Employer-Information.form.common.DateFormat"
                        )}
                      />
                      {state.dateOfHire?.error && (
                        <span className="error">{state.dateOfHire.error}</span>
                      )}
                    </div>
                  </div>

                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeeAddress"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeAddress1"
                        value={state.employeeAddress1.value}
                        ref={state.employeeAddress1.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employeeAddress1.isEditable}
                      ></textarea>
                      {state.employeeAddress1?.error && (
                        <span className="error">
                          {state.employeeAddress1.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeeAddress2"
                        )}
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeAddress2"
                        value={state.employeeAddress2.value}
                        ref={state.employeeAddress2.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employeeAddress2.isEditable}
                      ></textarea>
                      {state.employeeAddress2?.error && (
                        <span className="error">
                          {state.employeeAddress2.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Country"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {props.country && (
                        <DropdownComponent
                          name="country"
                          id="country"
                          options={props.country}
                          isMultiSelect={false}
                          option_key="countryId"
                          option_display="countryName"
                          onChange={(e) => {
                            onDropDownChange(e);
                          }}
                          values={state.country.value}
                          ref={state.country.ref}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        />
                      )}
                      {state.country?.error && (
                        <span className="error">{state.country.error}</span>
                      )}
                    </div>
                  </div>
                  
                  
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.Province"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {props.state && (
                        <DropdownComponent
                          name="province"
                          id="province"
                          options={props.state}
                          isMultiSelect={false}
                          option_key="provinceId"
                          option_display="province"
                          onChange={(e) => {
                            if (state.province.isEditable) {
                              onDropDownChange(e);
                            }
                          }}
                          values={state.province.value}
                          ref={state.province.ref}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        />
                      )}
                      {state.province?.error && (
                        <span className="error">{state.province.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.City"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="city"
                        value={state.city.value}
                        ref={state.city.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.city.isEditable}
                      />
                      {state.city?.error && (
                        <span className="error">{state.city.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.PostalCode"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={POSTAL_CODE_PLACEHOLDER}
                        name="postalCode"
                        value={state.postalCode.value}
                        ref={state.postalCode.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.postalCode.isEditable}
                      />
                      {state.postalCode?.error && (
                        <span className="error">{state.postalCode.error}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.Gender"
                        )}{" "}
                        &nbsp;
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Male"
                              name="gender"
                              value="Male"
                              checked={state.gender.value === "Male"}
                              onChange={(e)=>{
                              //if(!state.gender.isEditable)  
                                handleChanges(e);
                              }}
                              // readOnly={!state.gender.isEditable}
                            />
                            <label htmlFor="By-Male">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.Gender.option-Male"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Female"
                              name="gender"
                              value="Female"
                              checked={state.gender.value === "Female"}
                              onChange={(e)=>{
                                //if(!state.gender.isEditable)  
                                  handleChanges(e);
                                }}
                              // readOnly={!state.gender.isEditable}
                            />
                            <label htmlFor="By-Female">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.Gender.option-Female"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Undisclosed"
                              name="gender"
                              value="Undisclose"
                              checked={state.gender.value === "Undisclose"}
                              onChange={(e)=>{
                                //if(!state.gender.isEditable)  
                                  handleChanges(e);
                                }}
                              // readOnly={!state.gender.isEditable}
                            />
                            <label htmlFor="By-Undisclosed">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.Gender.option-Undisclosed"
                              )}
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeeTel"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={PHONE_PLACEHOLDER}
                        name="employeeTelephone"
                        maxLength="14"
                        value={state.employeeTelephone.value}
                        ref={state.employeeTelephone.ref}
                        onChange={handlePhoneNumber}
                        className="form-control"
                        readOnly={!state.employeeTelephone.isEditable}
                      />
                      {state.employeeTelephone?.error && (
                        <span className="error">
                          {state.employeeTelephone.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">

                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.Department"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="department"
                        value={state.department.value}
                        ref={state.department.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.department.isEditable}
                      />
                      {/* {state.department?.error && (
                        <span className="error">{state.department.error}</span>
                      )} */}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.JobTitle"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="employeeJobTitle"
                        value={state.employeeJobTitle.value}
                        ref={state.employeeJobTitle.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly={!state.employeeJobTitle.isEditable}
                      />
                      {state.employeeJobTitle?.error && (
                        <span className="error">
                          {state.employeeJobTitle.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.TimeInPosition"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="timeInPosition"
                        value={state.timeInPosition.value}
                        ref={state.timeInPosition.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.timeInPosition?.error && (
                        <span className="error">
                          {state.timeInPosition.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.UnionAffiliation"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Yes"
                              name="unionAffiliation"
                              value="Yes"
                              checked={state.unionAffiliation.value === "Yes"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Yes">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.UnionAffiliation.option-Yes"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-No"
                              name="unionAffiliation"
                              value="No"
                              checked={state.unionAffiliation.value === "No"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-No">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.UnionAffiliation.option-No"
                              )}
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employee-Information.form.label.text.EmployeePrefLang"
                        )}
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              id="lang-eng"
                              name="employeePrefLang"
                              value="ENG"
                              checked={state.employeePrefLang.value === "ENG"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="lang-eng">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.EmployeePrefLang.Eng"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="lang-fr"
                              name="employeePrefLang"
                              value="CFR"
                              checked={state.employeePrefLang.value === "CFR" || state.employeePrefLang.value === "FR"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="lang-fr">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.EmployeePrefLang.Fr"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="lang-Other"
                              name="employeePrefLang"
                              value="Other"
                              //checked={state.employeePrefLang.value === "Other"}
                              checked={state.employeePrefLang.value === "UNKNOWN"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="lang-Other">
                              {props.context.t(
                                "AIR-Employee-Information.form.label.text.EmployeePrefLang.Other"
                              )}
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name-File-Contact"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      
                      {props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature ?
                      <div className="Custom-select">
                        {props.supervisorList && (
                          <DropdownComponent
                            name="managerName"
                            id="managerName"
                            options={props.supervisorList}
                            isMultiSelect={false}
                            option_key="supervisorID_PK"
                            option_display="fullNameWithEmail"//"primaryName"
                            onChange={(e) => {
                              if (state.managerName.isEditable) {
                                onDropDownChange(e);
                              }
                            }}
                            values={state.managerName.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.managerName.ref}
                            readOnly={!state.managerName.isEditable}
                          />
                        )}
                        {state.managerName?.error && (
                          <span className="error">
                            {state.managerName.error}
                          </span>
                        )}
                      </div>
                      : <div>

                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t("ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere")}
                        // maxLength="50"
                        name="fileContactManagerName"
                        value={state.fileContactManagerName.value}
                        ref={state.fileContactManagerName.ref}
                        readOnly={!state.fileContactManagerName.isEditable}
                        onChange={handleChanges}
                        //readOnly={!state.managerName.isEditable}
                      />
                      {state.fileContactManagerName?.error && (
                        <span className="error">
                          {state.fileContactManagerName.error}
                        </span>
                      )}
                    </div>}
                    </div>
                  </div>
                  {/* <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                    <div className="form-group margin-top-30">
                      <a onClick={onAddManager} className="btn">
                        <img src={add} />
                      </a>
                    </div>
                  </div> */}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={PHONE_PLACEHOLDER}
                        maxLength="14"
                        name="managerTelephone"
                        value={state.managerTelephone.value}
                        ref={state.managerTelephone.ref}
                        onChange={handleChanges}
                        readOnly={!state.managerTelephone.isEditable}
                        //readOnly={!state.managerName.isEditable}
                      />
                      {state.managerTelephone?.error && (
                        <span className="error">
                          {state.managerTelephone.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={EMAIL_PLACEHOLDER}
                        name="managerEmail"
                        value={state.managerEmail.value}
                        ref={state.managerEmail.ref}
                        onChange={handleChanges}
                        readOnly={!state.managerEmail.isEditable}
                      />
                      {state.managerEmail?.error && (
                        <span className="error">
                          {state.managerEmail.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
               
                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    onClick={() => onSubmit(false, false)}
                    className="btn btn-blue"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-for-later.title"
                    )}
                  </a>
                  <a
                    tabIndex="0"
                    onClick={onSubmit}
                    className="btn btn-primary margin-left-5"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-and-move-next-step.title"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeInformation;
